// Copyright (C) 2021 Bystronic Laser AG

import moment from 'moment';
import { BendData, BendingPlanBendTimelineData } from './chartsData';
import { formatDuration } from '@/utils/dates';
import i18n from '@/i18n';
import { Color } from '@/utils/color';

export function tooltipFormatter(
  params: any,
  data: BendingPlanBendTimelineData,
  bendsPerPart: number,
) {
  if (params.componentType === 'markArea') {
    return formatMarkAreaTooltip(params);
  } else {
    return formatLineChartTooltip(params, data, bendsPerPart);
  }
}

export function isBendSequenceRepeated(
  index: number,
  entry: BendData,
  data: BendingPlanBendTimelineData,
  bendsPerPart: number,
) {
  return (
    index !== 0 &&
    data.bendData[index - 1].bendSequence === entry.bendSequence &&
    bendsPerPart > 1
  );
}

function formatMarkAreaTooltip(params: any) {
  const [[startTimestamp], [endTimestamp]]: [[string], [string]] =
    params.data.coord;
  const formattedDate = moment(startTimestamp).format('YYYY-MM-DD');
  const formatTime = (time: any) => moment(time).format('HH:mm:ss');
  return `
		<p style="color: rgba(74, 74, 74, 0.5)">${formattedDate}</p>
		<p style="font-weight: bold">${params.marker} ${params.data.name}</p>
		<p>${formatTime(startTimestamp)} - ${formatTime(endTimestamp)}</p>
		<p>${formatDuration(moment(endTimestamp).diff(startTimestamp) / 1000)}
	`;
}

function formatLineChartTooltip(
  params: any,
  data: BendingPlanBendTimelineData,
  bendsPerPart: number,
) {
  const dataIndex = params.dataIndex;
  const [timestamp, bendNumber, bendSequence] = params.value as [
    string,
    number,
    number,
  ];
  const formattedTimestamp = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
  const tooltipContent = `
		<p style="color:rgba(74,74,74, 0.5)"> ${formattedTimestamp}</p>
		<p>${i18n.t(
      'bend_detailed_production_plan_modal.bend_count',
    )}: <b>${bendNumber}</b></p>
	`;
  if (bendNumber === 0) {
    return tooltipContent;
  }

  const color = isBendSequenceRepeated(
    dataIndex,
    { timestamp, bendNumber, bendSequence },
    data,
    bendsPerPart,
  )
    ? Color.Red
    : 'inherit';
  return (
    tooltipContent +
    `
			<p>${i18n.t(
        'bend_detailed_production_plan_modal.bend_sequence',
      )}: <b style="color: ${color}">${bendSequence}</b></p>
		`
  );
}
